import { render, staticRenderFns } from "./TelnyxSettings.vue?vue&type=template&id=a0bf9738&scoped=true"
import script from "./TelnyxSettings.vue?vue&type=script&lang=js"
export * from "./TelnyxSettings.vue?vue&type=script&lang=js"
import style0 from "./TelnyxSettings.vue?vue&type=style&index=0&id=a0bf9738&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0bf9738",
  null
  
)

export default component.exports